import React from "react";
import EmergencyReadinessPreviewNav from "./EmergencyReadinessPreviewNav";
import EmergencyReadinessQuestionsPreview from "./EmergencyReadinessQuestionsPreview";
import EmergencyReadinessFlaggedPreview from "./EmergencyReadinessFlaggedPreview";
import EmergencyReadinessSignOffPreview from "./EmergencyReadinessSignOffPreview";
import ReadinessDetails from "../../../JobShiftReadiness/sections/ReadinessDetails";
import JobShiftReadinessViewHeader from "../../../JobShiftReadiness/JobShiftReadinessViewHeader";
import styles from "../PreviewV3.module.css";

const normalizeReadinessPreviewData = (response) => {
  if (!response || typeof response !== "object") {
    return { rescue_readiness_questions: {} };
  }

  if (response.rescue_readiness_questions) {
    return response;
  }

  const payload = response.data && typeof response.data === "object" ? response.data : response;
  const source = payload.emergency_readiness || payload.document || payload;
  const document = source.document && typeof source.document === "object" ? source.document : source;
  if (document.rescue_readiness_questions) {
    return document;
  }

  return { ...document, rescue_readiness_questions: document };
};

export default function EmergencyReadinessPreviewLayout({ swmsNumber, sections = {}, readiness }) {
  const readinessPreviewData = normalizeReadinessPreviewData(readiness);
  const readinessNumber = swmsNumber ? `${swmsNumber}-RDY` : "";

  return (
    <div className={`${styles.PreviewWrap} ${styles.EmergencyReadinessPreviewDocument}`}>
      <EmergencyReadinessPreviewNav readinessNumber={readinessNumber} />
      <main>
        <div className={styles.PreviewDoc}>
          <JobShiftReadinessViewHeader
            sections={sections}
            readiness={readinessPreviewData}
            context={{ swmsNumber, readinessDocumentNumber: readinessNumber }}
            rightClassName="preview-prestart-header-right"
          />
          <div id="emergency-readiness-sec-details" className={styles.PreviewSectionAnchor}>
            <ReadinessDetails
              sections={sections}
              readinessData={readinessPreviewData}
              swmsNumber={swmsNumber}
            />
          </div>
          <div id="emergency-readiness-sec-questions" className={styles.PreviewSectionAnchor}>
            <EmergencyReadinessQuestionsPreview readiness={readinessPreviewData} />
          </div>
          <div id="emergency-readiness-sec-flagged" className={styles.PreviewSectionAnchor}>
            <EmergencyReadinessFlaggedPreview />
          </div>
          <div id="emergency-readiness-sec-signoff" className={styles.PreviewSectionAnchor}>
            <EmergencyReadinessSignOffPreview readiness={readinessPreviewData} />
          </div>
        </div>
      </main>
    </div>
  );
}
